import { takeEvery, all, select, put } from 'redux-saga/effects';
import {
  APPLY_USER_FILTERS,
  FILTER_DEFAULT_LIMIT,
  REQUEST_USER_FILTER,
  REQUEST_USER_FILTER_RESET,
  REQUEST_USERS,
  REQUEST_WEBSITE_USER_FILTER,
  REQUEST_WEBSITE_USERS,
} from './constants';
import { GET_MY } from '../../containers/App/constants';
import { selectUserFilter, selectWebsiteUserFilter } from './selectors';

function* requestUserFilter() {
  let filter = yield select(selectUserFilter());

  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString || null;
  const sortType = filter?.sortType;
  const order = filter?.order;

  // let path = `users?offset=${offset}&limit=${limit}${text ? `&text=${text}` : ''}`;
  let path = `users/getList`;

  let searchParams = {
    offset,
    limit,
    text: text ?? undefined,
    status: filter?.status ?? 'ACTIVE',
    filters: filter.properties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f)),
  };

  if (!!sortType) {
    searchParams.sortType = sortType;
    searchParams.order = order ?? 'desc';
  }

  yield put({
    type: GET_MY,
    id: REQUEST_USERS,
    work: REQUEST_USERS,
    gate: REQUEST_USERS,
    path,
    post: searchParams,
  });
}

function* requestWebsiteUserFilter() {
  let filter = yield select(selectWebsiteUserFilter());

  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString || null;

  let path = `website-admin/users?offset=${offset}&limit=${limit}${text ? `&text=${text}` : ''}`;
  if (!!filter.mainFilter && filter.mainFilter != 'all') path += `&${filter.mainFilter}=1`;

  yield put({
    type: GET_MY,
    id: REQUEST_WEBSITE_USERS,
    work: REQUEST_WEBSITE_USERS,
    gate: REQUEST_WEBSITE_USERS,
    path,
  });
}

export function* usersSaga() {
  yield all([
    takeEvery(REQUEST_USER_FILTER, requestUserFilter),
    takeEvery(APPLY_USER_FILTERS, requestUserFilter),
    takeEvery(REQUEST_USER_FILTER_RESET, requestUserFilter),
  ]);
  yield all([takeEvery(REQUEST_WEBSITE_USER_FILTER, requestWebsiteUserFilter)]);
}
